import JourneyRoute from "./JourneyRoute.vue";
export default JourneyRoute;
